/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cross } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6" data-testid="not-found-page">
      <div className="text-center">
        <Cross className="h-8 w-8 text-accent mx-auto" strokeWidth={1.5} />
        <p className="mt-4 overline">404</p>
        <h1 className="mt-3 font-serif text-5xl md:text-6xl text-primary">Page not found</h1>
        <p className="mt-4 text-muted-foreground">The road you're on isn't on our map.</p>
        <Button asChild className="mt-8 rounded-sm" data-testid="notfound-home">
          <Link to="/">Back home</Link>
        </Button>
      </div>
    </div>
  );
}
